import moment from '@/moment-gp'

export default {

  create({ name, user_id }, data) {
    return {
      createdAt:                  moment.currentTimeServer('REALTIMEDB'),
      createdBy:                  user_id,
      name:                       name,
      description:                'Description...',
      picture:                    '',
      sortidx:                    data.sortidx || 0 ,
      /* template ... */
      templateId:                 data.template_id || null,
      /* How many times should this sequence be repeated? */
      templateRepeat:             data.templateRepeat || 100,
      /* Id of the last item/session in the sequence, that was last finished. */
      lastCompletedSeqItemId:     data.lastCompletedSeqItemId || null,
      /* How many times has the sequence alreday been repeated? */
      completedSequences:         data.completedSequences || 0,
      /* Array of Sequence items. See empty_session_template_item */
      sequenceItemList:           data.sequenceItemList || [ /* sesion template items */ ],
      // NEU 17.12.2018
      allowSessionToBeSkipped:    data.allowSessionToBeSkipped || false,
      // NEU 20.3.2019
      owner:                      user_id, /* who owns the sequence */
      viewers:                    {},      /* who can view (edit?) the sequence */
    }
  },

  fields: {
    createdAt: { validate_bolt_type: 'ServerTimestamp' },
    createdBy: {},
    name: {},
    description: {},
    picture: {},
    sortidx: {},
    templateId: {},
    templateRepeat: {},
    lastCompletedSeqItemId: {},
    completedSequences: {},
    sequenceItemList: {
      // validate_bolt_type: 'Map<ID, SequenceItem>'
      validate_bolt_type: 'SequenceItem[]'
    },
    allowSessionToBeSkipped: {},
    owner: {},
    viewers: {},
    "/viewers/([a-zA-Z0-9]{28})$/": {},
  }
};
